var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.183,
    height: 22.779,
    viewBox: "0 0 19.183 22.779",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-5{stroke:none}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_975",
    transform: "translate(-1824 -568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_296",
    fill: "#d5d5d5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.985 22.28H3.197C1.71 22.28.5 21.07.5 19.581V3.197C.5 1.71 1.71.5 3.197.5h9.63c.794.738 5.003 4.728 5.856 5.552v13.53c0 1.487-1.21 2.697-2.698 2.697z",
    className: "cls-5",
    transform: "translate(1824 568)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M3.197 1C1.986 1 1 1.986 1 3.197v16.385c0 1.212.986 2.197 2.197 2.197h12.788c1.212 0 2.198-.985 2.198-2.197V6.266C17.145 5.273 13.635 1.938 12.632 1H3.197m0-1h9.823c.151.114 6.151 5.817 6.163 5.842v13.74c0 1.766-1.432 3.197-3.198 3.197H3.197C1.431 22.78 0 21.348 0 19.582V3.197C0 1.431 1.431 0 3.197 0z",
    transform: "translate(1824 568)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    fill: "#707070",
    stroke: "#707070",
    strokeLinejoin: "round",
    d: "M6444.182-10332.422h-.141v5.475h5.627v-.352z",
    transform: "translate(-4607.237 10901.29)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_285",
    fill: "#707070",
    stroke: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14.737A.263.263 0 0 1 15 .263 4.737 4.737 0 0 1 10.263 5H0V0z",
    className: "cls-5",
    transform: "translate(1824 581.78)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.554.5h13.784a.162.162 0 0 1 .162.162A3.838 3.838 0 0 1 10.662 4.5H.554A.054.054 0 0 1 .5 4.446V.554A.054.054 0 0 1 .554.5z",
    transform: "translate(1824 581.78)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    fill: "#d5d5d5",
    d: "M-7.964-5.175v1.052h-.615v-2.986h1.165a1.348 1.348 0 0 1 .592.123.907.907 0 0 1 .393.35.975.975 0 0 1 .137.516.858.858 0 0 1-.3.692 1.252 1.252 0 0 1-.832.253zm0-.5h.55a.541.541 0 0 0 .372-.115.418.418 0 0 0 .128-.328.493.493 0 0 0-.129-.355.483.483 0 0 0-.357-.14h-.564zm2.095 1.551v-2.985h.919a1.4 1.4 0 0 1 .7.177 1.237 1.237 0 0 1 .485.5 1.557 1.557 0 0 1 .174.744v.137a1.561 1.561 0 0 1-.171.741 1.227 1.227 0 0 1-.483.5 1.406 1.406 0 0 1-.7.181zm.615-2.489v1.994h.3a.668.668 0 0 0 .554-.234 1.066 1.066 0 0 0 .195-.675v-.158a1.083 1.083 0 0 0-.189-.69.666.666 0 0 0-.552-.235zm3.912 1.268h-1.181v1.221h-.615v-2.985h1.945v.5h-1.33v.771h1.182z",
    transform: "translate(1835.583 589.706)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.e4b7a8585995d7410495c88073d433f4.svg";
export { ForwardRef as ReactComponent };